import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "size", "type", "icon", "disabled", "active", "float"];
import React, { memo, forwardRef } from 'react';
import { mergeRestProps } from '../../common/index';
import { Wrap } from './styled';
export var Button = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((props, ref) => {
  var {
      children,
      size = 'normal',
      type: type_ = 'secondary',
      icon,
      disabled = false,
      active = false
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var type = type_ === 'normal' ? 'secondary' : type_;
  return /*#__PURE__*/React.createElement(Wrap, _extends({
    ref: ref,
    size: size,
    btnType: type,
    disabled: disabled,
    content: icon && children ? 'icon-text' : children ? 'only-text' : 'only-icon',
    type: "button"
  }, mergeRestProps(rest, "wdn-button " + (active ? 'active' : ''))), icon, children);
}));
//# sourceMappingURL=Button.js.map